import React, { useEffect, useState } from "react";
import { Navbar, Nav, Modal, Button, Badge } from "react-bootstrap";
import { ReactComponent as Logo } from "../../assets/SenseAbleIcon.svg";
import { faBell } from "@fortawesome/free-solid-svg-icons";
import "./UserCSS/NavbarComponent.css";
import { useNavigate, Link } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { logoutUser } from "../../redux/slices/authSlice";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faUserCircle } from "@fortawesome/free-solid-svg-icons";
import toast from "react-hot-toast";

// Watch alerts (AlertSlice)
import { fetchAlertsByUser } from "../../redux/slices/AlertSlice";
// Fall alerts (AlertTableSlice)
import { fetchFallAlertsByUser } from "../../redux/slices/AlertTableSlice";

function NavbarComponent() {
  const [show, setShow] = useState(false);
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const user = useSelector((state) => state.auth.user);

  // ── Fetch both alert types as soon as navbar mounts and user is available ──
  useEffect(() => {
    if (user?.user_id) {
      dispatch(fetchAlertsByUser(user.user_id));       // watch alerts
      dispatch(fetchFallAlertsByUser(user.user_id));   // fall alerts
    }
  }, [dispatch, user]);

  // Watch alerts → state.alerts (AlertSlice)
  const watchAlerts = useSelector((state) => state.alerts.alerts || []);
  const watchUnacknowledged = watchAlerts.filter((a) => !a.acknowledged).length;

  // Fall alerts → state.fallAlerts (AlertTableSlice)
  const fallAlerts = useSelector((state) => state.fallAlerts.alerts || []);
  const fallUnacknowledged = fallAlerts.filter((a) => !a.alert_acknowledged).length;

  // Combined count shown on the bell
  const totalUnacknowledged = watchUnacknowledged + fallUnacknowledged;

  const handleClose = () => setShow(false);
  const handleShow  = () => setShow(true);

  const handleLogout = async () => {
    localStorage.removeItem("access_token");
    dispatch(logoutUser());
    toast.success("Logged out successfully");
    setTimeout(() => {
      navigate("/login", { replace: true });
    }, 1000);
  };

  return (
    <>
      <Navbar bg="dark" variant="dark" expand="lg" className="px-3">
        <Navbar.Brand href="#home">
          <Logo />
        </Navbar.Brand>
        <Navbar.Toggle aria-controls="basic-navbar-nav" />
        <Navbar.Collapse id="basic-navbar-nav">
          <Nav className="ms-auto">
            <Nav.Link
              as={Link}
              to="/useralerts"
              style={{ display: "inline-flex", alignItems: "center" }}
            >
              <span
                style={{
                  position: "relative",
                  display: "inline-block",
                  marginRight: 7,
                }}
              >
                <FontAwesomeIcon
                  icon={faBell}
                  className={`bell-alert${totalUnacknowledged > 0 ? " bell-alert-animate" : ""}`}
                  style={{ fontSize: "1.2em", verticalAlign: "middle" }}
                />
                {totalUnacknowledged > 0 && (
                  <Badge
                    bg="danger"
                    pill
                    style={{
                      position: "absolute",
                      top: -6,
                      right: -10,
                      fontSize: "0.7em",
                      padding: "0.15em 0.4em",
                      pointerEvents: "none",
                    }}
                  >
                    {totalUnacknowledged}
                  </Badge>
                )}
              </span>
              <span
                style={{
                  verticalAlign: "middle",
                  fontSize: "1em",
                  fontWeight: 500,
                }}
              >
                Alerts
              </span>
            </Nav.Link>

            <Nav.Link onClick={handleShow}>Profile</Nav.Link>
            <Nav.Link href="#settings">Settings</Nav.Link>
          </Nav>
        </Navbar.Collapse>
      </Navbar>

      <Modal show={show} onHide={handleClose} centered>
        <Modal.Header closeButton>
          <Modal.Title>Profile</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {user ? (
            <div className="profile-info text-center">
              <FontAwesomeIcon icon={faUserCircle} size="5x" className="mb-3" />
              <p>
                <strong>User ID:</strong> {user.user_id}
              </p>
              <p>
                <strong>Username:</strong> {user.user_name}
              </p>
              <p>
                <strong>Email:</strong> {user.email}
              </p>
              <Button
                variant="danger"
                onClick={handleLogout}
                className="w-100 mt-3"
              >
                Logout
              </Button>
            </div>
          ) : (
            <p>Loading user data...</p>
          )}
        </Modal.Body>
      </Modal>
    </>
  );
}

export default NavbarComponent;